import Layout from '../common/Layout'
import Bottom from './Bottom'
import LeftBar from './header/LeftBar'
import { SelectScore } from './header/SelectScore'

const PortfolioSegment = () => {
  return (
    <Layout
      hasCurrencyUnit
      renderCustomHeader={() => <SelectScore />}
      renderLeftBar={() => <LeftBar />}
      renderBottom={() => <Bottom />}
    />
  )
}

export default PortfolioSegment
